const routes = {
  home: '/',
  userBooking: '/lich-cua-toi',
  booking: '/len-lich',
  profile: '/me',
  voucher: '/giam-gia'
}

export default routes
